module.exports = __webpack_public_path__ + "static/media/final-r.3c7e89ac.png";